var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFriendBlue = function SvgIconFriendBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-profile",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(-2 -2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M207.109 156.024c0-1.778-2.153-3.225-4.8-3.225s-4.8 1.447-4.8 3.225V157h9.6Z",
    transform: "translate(-194.509 -142.499)",
    fill: "#1eaae1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 3.3,
    cy: 3.3,
    r: 3.3,
    transform: "translate(4.6 2.5)",
    fill: "#2980b9"
  }))));
};
export { SvgIconFriendBlue as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iaWNvbi1wcm9maWxlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDEyIDEyIj4KICA8cmVjdCBpZD0iUmVjdGFuZ2xlXzIwIiBkYXRhLW5hbWU9IlJlY3RhbmdsZSAyMCIgd2lkdGg9IjEyIiBoZWlnaHQ9IjEyIiBmaWxsPSIjZmZmIiBvcGFjaXR5PSIwIi8+CiAgPGcgaWQ9Ikdyb3VwXzIwIiBkYXRhLW5hbWU9Ikdyb3VwIDIwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMiAtMi41KSI+CiAgICA8cGF0aCBpZD0iUGF0aF8yNCIgZGF0YS1uYW1lPSJQYXRoIDI0IiBkPSJNMjA3LjEwOSwxNTYuMDI0YzAtMS43NzgtMi4xNTMtMy4yMjUtNC44LTMuMjI1cy00LjgsMS40NDctNC44LDMuMjI1VjE1N2g5LjZaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTk0LjUwOSAtMTQyLjQ5OSkiIGZpbGw9IiMxZWFhZTEiLz4KICAgIDxjaXJjbGUgaWQ9IkVsbGlwc2VfNiIgZGF0YS1uYW1lPSJFbGxpcHNlIDYiIGN4PSIzLjMiIGN5PSIzLjMiIHI9IjMuMyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNC42IDIuNSkiIGZpbGw9IiMyOTgwYjkiLz4KICA8L2c+Cjwvc3ZnPgo=";